export type StreamChatView = 'list' | 'chat' | 'thread';
export const OPEN_STREAM_CHAT_MODAL_ROUTE = 'modal:chat';